module.exports = __webpack_public_path__ + "static/media/react.a3163ac7.svg";